import {
  AssetReviewCommentsControllerGetAssetCommentsParams,
  AssetVersionCommentDto
} from '@api/Api';
import { getCommentsAssetReview } from '@api/AssetReview';
import { getPlaceholderArrayQuery } from '@hooks/queries/helpers';
import { useQuery } from '@tanstack/react-query';

export const QUERY_COMMENTS_ASSETS = 'comments_assets';

export function useCommentsAssetReviewQuery(
  params: AssetReviewCommentsControllerGetAssetCommentsParams,
  options?: {
    enabled?: boolean;
    keepPreviousData?: boolean;
    placeholderData?: AssetVersionCommentDto[];
  }
) {
  return useQuery({
    ...(options ?? {}),
    queryKey: [QUERY_COMMENTS_ASSETS, params.assetVersionId, params],
    queryFn: async ({ signal }) => {
      const { data } = await getCommentsAssetReview(params, {
        signal
      });
      return data.comments;
    },
    placeholderData: () => {
      if (options?.placeholderData) return options.placeholderData;
      const comments = getPlaceholderArrayQuery<AssetVersionCommentDto>([
        QUERY_COMMENTS_ASSETS,
        params.assetVersionId
      ]);
      if (!comments) return undefined;
      return comments;
    }
  });
}
